// 设置 → 语音输入：用哪个识别模型（只记在这台设备上），和一个试一试的框。

import { useRef, useState } from 'react'
import { Check } from 'lucide-react'
import { MicButton, VOICE_MODELS, setVoiceModel, useDictation, useVoiceModel } from './VoiceInput'

export function VoiceSettings() {
  const current = useVoiceModel()
  const [text, setText] = useState('')
  const box = useRef<HTMLTextAreaElement>(null)
  const voice = useDictation({ value: text, onChange: setText, inputRef: box })
  return (
    <>
      <section className="settings-card" aria-label="语音输入">
        <div className="settings-h">
          <h2>语音输入</h2>
        </div>
        <p className="field-note">输入框旁边的麦克风：点一下开始说，字边说边进输入框；再点一下停，15 秒没听到声音也会自己停，一次最多 5 分钟。说着话的时候点发送，会等最后几个字进来再发。</p>
        <div className="voice-models" role="radiogroup" aria-label="识别模型">
          {VOICE_MODELS.map((m) => (
            <button key={m.id} type="button" role="radio" aria-checked={m.id === current} className="voice-model" onClick={() => setVoiceModel(m.id)}>
              <Check className="tick" width={15} height={15} aria-hidden="true" />
              <span className="name">{m.label}</span>
              <span className="note">{m.note}</span>
            </button>
          ))}
        </div>
        <p className="field-note">用的是阿里云百炼的实时语音识别，和对话模型同一个账号。声音经灵智原生的服务器转给阿里云，识别完就丢，不存录音、不存文字。识别模型只记在这台设备上。</p>
      </section>
      <section className="settings-card" aria-label="试一下">
        <div className="settings-h">
          <h2>试一下</h2>
        </div>
        <div className="voice-try">
          <textarea ref={box} rows={4} value={text} onChange={(e) => setText(e.target.value)} readOnly={voice.active} data-dictating={voice.active} placeholder="点右边的麦克风，说一句话" aria-label="试一下语音输入" />
          <MicButton d={voice} />
        </div>
      </section>
    </>
  )
}
